import React, { Component } from 'react';

class CheckboxDropdown extends Component {
    constructor(props) {
        super();

        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.showName = this.showName.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);

        this.dropdownRef = React.createRef();
        this.state = {
            isOpen: false,
            selectedOptions: props.alreadySelected ?? [],
            searchValue: '',
            searchedOptions: [...props.options],
        };
    }

    handleClickOutside(event) {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({
                isOpen: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.values) !== JSON.stringify(this.props.values)) {
            this.setState({
                selectedOptions: this.props.values ?? [],
                searchValue: '',
                searchedOptions: [...this.props.options],
            });
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    toggleDropdown() {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    handleCheckboxChange(option) {
        this.setState({
            selectedOptions: this.state.selectedOptions.includes(option)
                ? this.state.selectedOptions.filter((item) => item !== option)
                : [...this.state.selectedOptions, option],
        });
    }

    handleApply() {
        this.props.onApply(this.state.selectedOptions);
        this.toggleDropdown();
    }

    showName() {
        if (this.props.showCustomHeader) {
            return this.props.showCustomHeader({
                selectedOptions: this.state.selectedOptions,
                options: this.props.options,
                defaultLabel: this.props.label,
                flag: this.props.flag,
            });
        }
        if (this.state.selectedOptions.length) {
            const names = this.props.options
                .filter((item) => this.state.selectedOptions.includes(item.value))
                .map((item) => item.label)
                .join(', ');
            return names;
        }
        return this.props.label;
    }

    handleSearchChange(event) {
        const searchValue = event.target.value;
        this.setState({
            searchValue,
            searchedOptions: this.props.options.filter((option) =>
                option.label.toLowerCase().includes(searchValue.toLowerCase()),
            ),
        });
    }

    render() {
        const options = this.state.searchValue ? this.state.searchedOptions : this.props.options;
        return (
            <div className="checkbox-dropdown" ref={this.dropdownRef}>
                <button onClick={this.toggleDropdown} className="dropdown-btn">
                    <span className="checkbox-dropdown-text">{this.showName()}</span>
                    <div className="dropdown-arrow">
                        <i className="icon-arrow-down"></i>
                    </div>
                </button>
                {this.state.isOpen && (
                    <div className="dropdown-content">
                        {this.props.hasSearch && (
                            <div>
                                <input
                                    className="form-control mt-10"
                                    value={this.state.searchValue}
                                    onChange={this.handleSearchChange}
                                    placeholder="Search..."
                                />
                            </div>
                        )}
                        <div className="dropdown-content-body">
                            {options.map((option, index) => (
                                <label className="checkbox-dropdown-option" key={index}>
                                    <input
                                        type="checkbox"
                                        value={option.value}
                                        checked={this.state.selectedOptions.includes(option.value)}
                                        onChange={() => this.handleCheckboxChange(option.value)}
                                    />
                                    {option?.showedValue ?? option.label}
                                </label>
                            ))}
                        </div>
                        <button onClick={this.handleApply} className="apply-btn">
                            Apply
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default CheckboxDropdown;
